import React from "react";
import { StyleProp, ViewStyle } from "react-native";
import { AHText, TouchableBox } from "arkh";
import { RowItem } from "./components";
import { TaskTypeIcon, TaskTypeIconSize } from "../../../types/TaskTypeIcon";
import { TaskTypesType } from "../../../types/TaskUIType";

export function TasksColumn(props: {
  onPress: (taskId: string) => void;
  tasks: { title: string; id: string; __typename: TaskTypesType }[];
}) {
  return (
    <>
      {props.tasks.map((task) => {
        return (
          <TouchableBox
            key={task.id}
            onPress={() => {
              props.onPress(task.id);
            }}
          >
            <RowItem style={rowStyle} spaceRight="small">
              <TaskTypeIcon type={task} size={TaskTypeIconSize.XXSMALL} />
              <AHText
                spaceLeft="xsmall"
                type="subtitle"
                ellipsizeMode="tail"
                style={{
                  textAlignVertical: "center",
                }}
                numberOfLines={2}
              >
                {task.title}
              </AHText>
            </RowItem>
          </TouchableBox>
        );
      })}
    </>
  );
}
const rowStyle: StyleProp<ViewStyle> = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
};
